import { Link } from 'react-router-dom';

const AboutPreview = () => {
  return (
    <section className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-wider text-forest/70 mb-6">WHO WE ARE</p>
          
          <h2 className="font-serif text-5xl font-normal text-gray-900 leading-tight mb-20">
            Local Experts<br />
            Sharing Hidden<br />
            Valley Gems
          </h2>

          <div className="flex gap-4">
            <Link
              to="/about"
              className="px-8 py-3 bg-forest text-white rounded-full font-medium hover:bg-forest-light transition-colors whitespace-nowrap"
            >
              Read Our Story
            </Link>
            <a
              href="#team"
              className="px-8 py-3 border-2 border-gray-900 text-gray-900 rounded-full font-medium hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Meet the Team
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;